import useApi from "@/hooks/useApi";
import { PrimaryBlueButton } from "@velaro/velaro-component-lib";
import { LoadingSpinner } from "@velaro/velaro-component-lib";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "@velaro/velaro-component-lib";
import React, { useState } from "react";

interface FormstackConfig {
  displayName: string;
  token: string;
}

interface Props {
  config: FormstackConfig;
  modalType: "edit" | "add";
  handleSubmit(config: FormstackConfig): void;
  handleModalClose(): void;
}

export default function FormstackModal(props: Props) {
  const [config, setConfig] = React.useState<FormstackConfig>(props.config);
  const [displayName, setDisplayName] = React.useState(
    props.config.displayName
  );
  const [token, setToken] = React.useState(props.config.token);

  React.useEffect(() => {
    setConfig({ displayName, token });
  }, [displayName, token]);

  return (
    <div>
      <Modal show={true}>
        <form
          // className="px-4"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <ModalBody>
            {props.modalType == "edit" && (
              <div className="text-center text-slate-900 text-xl font-medium mb-6">
                Edit Formstack Configuration
              </div>
            )}
            {props.modalType == "add" && (
              <div className="text-center text-slate-900 text-xl font-medium mb-6">
                Add Formstack Configuration
              </div>
            )}
            <div className="flex flex-col gap-1 mb-4">
              <label className="text-slate-800 text-sm font-medium">
                Display Name
              </label>
              <input
                type="text"
                className="px-4 py-2 bg-white rounded-lg border border-slate-300 w-full"
                value={displayName}
                placeholder="Enter display name"
                onChange={(e) => setDisplayName(e.currentTarget.value)}
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-slate-800 text-sm font-medium">
                Formstack Access Token
              </label>
              <input
                type="text"
                className={`px-4 py-2 bg-white rounded-lg border transition-colors duration-200 "border-red-500 focus:border-red-500"`}
                value={token}
                placeholder="Enter token"
                onChange={(e) => setToken(e.currentTarget.value)}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="p-4 flex place-self-center gap-3">
              <button
                onClick={() => props.handleModalClose()}
                className="rounded-lg justify-start items-center flex px-6 py-2 bg-white rounded-lg border border-primary hover:border-primary-hover text-center text-[#1670e7] text-sm font-medium"
              >
                Cancel
              </button>

              <button
               onClick={() => props.handleSubmit(config)}
              className="rounded-lg justify-start items-center flex px-6 py-2 rounded-lg border border-primary bg-primary border-primary hover:bg-primary-hover hover:border-primary-hover text-center text-white text-sm font-medium"
            >
              Save
            </button>

              {/* <div className="ml-auto flex flex-row">
                <PrimaryBlueButton
                  onClick={() => props.handleSubmit(config)}
                  label="Save"
                />
              </div> */}
            </div>
          </ModalFooter>
        </form>
      </Modal>
    </div>
  );
}
